<app-horizontal-page>
  <app-horizontal-page-content>
    <h1>Pagina niet gevonden</h1>

    De gekozen resource kan niet gevonden worden.
  </app-horizontal-page-content>
</app-horizontal-page>
